import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from '../services/auth.service'; // Adjust the path as necessary

@Injectable({
  providedIn: 'root'
})
export class AuthorizeGuard {
  constructor(private authService: AuthService, private router: Router) {
  }

  canActivate: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const expectedPermission: string = route.data['expectedPermission'];
    if (expectedPermission && expectedPermission.length > 0 && !this.authService.hasPermission(expectedPermission)) {
      this.router.navigate(['/unauthorized']);
      return false;
    }
    return true;
  };
}
